import { navigate } from 'gatsby'
import { useSnackbar } from 'notistack'
import { useEffect } from 'react'
import { tap } from 'rxjs'

import { getPatientBrowseDispensaryToastActions } from '../../../components/dispensaries/toasts/PatientBrowseDispensaryToastActions'
import { latestExternalNotify$ } from '../effects/notify'
import { DispensaryExternalEffectNotify } from '../effects/types'
import { addDispensaryBasePathToPath } from '../utils'

const TOAST_ID = 'patient-browse-dispensary'

const navigateToDispensary = (dispensary: DispensaryExternalEffectNotify['dispensary']) => () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/'
  const navigatePath = addDispensaryBasePathToPath(dispensary.slug, path)
  navigate(navigatePath)
}

export const usePatientBrowseDispensaryToast = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  useEffect(() => {
    const subscription = latestExternalNotify$
      .pipe(
        tap((effect) => {
          if (effect == null) {
            return closeSnackbar(TOAST_ID)
          }

          enqueueSnackbar(
            `Enjoy a seamless shopping experience tailored to your needs. Click here to browse your Practitioner's Dispensary!`,
            {
              variant: 'info',
              action: getPatientBrowseDispensaryToastActions({ dismissToast: effect.ack }),
              key: TOAST_ID,
              persist: true,
              preventDuplicate: true,
              style: {
                cursor: 'pointer',
              },
              onClick: navigateToDispensary(effect.dispensary),
            },
          )
        }),
      )
      .subscribe()
    return () => subscription.unsubscribe()
  }, [closeSnackbar, enqueueSnackbar])
}
